// extracted by mini-css-extract-plugin
export default {"section":"Projects_section__G+CvC","sectionTitle":"Projects_sectionTitle__MkRJV"};